import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as o, normalizeClass as r, createElementVNode as e } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBellOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], f = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.884 10.068a.5.5 0 0 1 .684.181.5.5 0 0 0 .865 0 .5.5 0 0 1 .865.502 1.5 1.5 0 0 1-2.595 0 .5.5 0 0 1 .181-.683Z"
}, null, -1), h = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 9a.5.5 0 0 1-.283-.912l.001-.001a1.51 1.51 0 0 0 .153-.142c.113-.118.274-.318.44-.622.33-.606.689-1.646.689-3.322v-.794L.646 1.354a.5.5 0 1 1 .708-.708l10 10a.5.5 0 0 1-.708.708L8.293 9H1.5Zm1.075-1c.038-.062.076-.128.114-.198.404-.74.781-1.887.81-3.597L7.292 8H2.575Z"
}, null, -1), p = /* @__PURE__ */ e("path", { d: "M9.797 6.368a8.444 8.444 0 0 1-.297-2.36v-.007a3.5 3.5 0 0 0-5.442-2.917.5.5 0 0 0 .555.832A2.5 2.5 0 0 1 8.5 3.994v-.002.007-.006c-.014.891.098 1.78.333 2.639a.5.5 0 1 0 .964-.264Z" }, null, -1), m = [
  f,
  h,
  p
], v = ["id"], g = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), I = [
  g
];
function b(a, q, l, S, z, t) {
  return o(), n("svg", {
    "aria-label": l.ariaLabel,
    class: r([t.iconSizeClass, "d-icon d-icon--bell-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Bell Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`,
      fill: "currentColor"
    }, m, 8, u),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, I, 8, v)
    ])
  ], 10, _);
}
const D = /* @__PURE__ */ s(c, [["render", b]]);
export {
  D as default
};
//# sourceMappingURL=bell-off.js.map
